module.exports = __webpack_public_path__ + "static/media/leaf01.d69a8087.png";